import React, {useEffect, useState} from 'react';
import MenuLink from 'components/MenuLink';
import {Hidden, Tabs} from '@material-ui/core';
import {FormattedMessage, useIntl} from 'react-intl';
import useStyles from './SupportMenu.styles';
import {useCurrentRoute} from 'react-navi';

export default function ({selected}) {
    let classes = useStyles();
    let [selectedMenuItem, setSelectedMenuItem] = useState(false);
    let intl = useIntl();
    let route = useCurrentRoute();
    let links = [
        {
            label: <FormattedMessage
                id="components.SupportMenu.general"
                defaultMessage={`General`}
            />,
            url: intl.formatMessage({
                id: 'url.support.general',
                defaultMessage: '/support/general/',
            }),
        },
        {
            label: <FormattedMessage
                id="components.SupportMenu.order"
                defaultMessage={`Order`}
            />,
            url: intl.formatMessage({
                id: 'url.support.order',
                defaultMessage: '/support/order/',
            }),
        },
        {
            label: <FormattedMessage
                id="components.SupportMenu.payment"
                defaultMessage={`Payment`}
            />,
            url: intl.formatMessage({
                id: 'url.support.payment',
                defaultMessage: '/support/payment/',
            }),
        },
        {
            label: <FormattedMessage
                id="components.SupportMenu.technical"
                defaultMessage={`Technical`}
            />,
            url: intl.formatMessage({
                id: 'url.support.technical',
                defaultMessage: '/support/technical/',
            }),
        },
        {
            label: <FormattedMessage
                id="components.SupportMenu.serviceWarranty"
                defaultMessage={`Service & Warranty`}
            />,
            url: intl.formatMessage({
                id: 'url.support.serviceWarranty',
                defaultMessage: '/support/service-warranty/',
            }),
        },
    ];

    useEffect(() => {
        if (selected === 'general') {
            setSelectedMenuItem(0);
        } else if (selected === 'order') {
            setSelectedMenuItem(1);
        } else if (selected === 'payment') {
            setSelectedMenuItem(2);
        } else if (selected === 'technical') {
            setSelectedMenuItem(3);
        } else if (selected === 'serviceWarranty') {
            setSelectedMenuItem(4);
        } else {
            setSelectedMenuItem(false);
        }
    }, [route, setSelectedMenuItem, selected]);

    return (
        <div className={classes['root']}>
            <Hidden xsDown>
                <span className={classes['__label']}>
                <FormattedMessage
                    id="components.SupportMenu.customerSupport"
                    defaultMessage={`Customer Support`}
                />:
            </span>
            </Hidden>
            <Tabs
                textColor="primary"
                indicatorColor="primary"
                value={selectedMenuItem}
                classes={{
                    flexContainer: classes['__container'],
                    indicator: classes['__indicator'],
                }}
            >
                {links.map((link, index) => (
                    <MenuLink
                        key={index}
                        label={link.label}
                        url={link.url}
                    />
                ))}
            </Tabs>
        </div>
    );
}
